import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.css';
import logo from '../../assets/images/logo.png';
import sidebar_items from '../../assets/JsonData/sidebar_routes.json';

const SidebarItem = ({ title, icon, active, es_padre, toggleSubmenu }) => {
  return (
    <div className="sidebar__item" onClick={toggleSubmenu}>
      <div className={`sidebar__item-inner ${active ? 'active' : ''}`}>
        <i className={icon}></i>
        <span>{title}</span>
        {es_padre && <i className="bx bx-chevron-down"></i>}
      </div>
    </div>
  );
};

const Sidebar = () => {
  const location = useLocation();
  const pathname_array = location.pathname.split('/');
  const activeItem = sidebar_items.findIndex((item) => item.route === `/${pathname_array[1]}`);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const toggleSubmenu = (index) => {
    setOpenSubmenu((prev) => (prev === index ? null : index));
  };

  const closeAllSubmenus = (event) => {
    if (!event.target.closest('.sidebar')) {
      setOpenSubmenu(null);
    }
  };

  useEffect(() => {
    document.addEventListener('click', closeAllSubmenus);
    return () => {
      document.removeEventListener('click', closeAllSubmenus);
    };
  }, []);

  return (
    <div className="sidebar">
      <div className="sidebar__logo">
        <img src={logo} alt="company logo" />
      </div>
      {sidebar_items.map((item, index) => (
        <div key={index}>
          {item.submenu ? (
            <>
              <SidebarItem
                title={item.display_name}
                icon={item.icon}
                active={index === activeItem}
                es_padre={true}
                toggleSubmenu={() => toggleSubmenu(index)}
              />
              <div className={`submenu ${openSubmenu === index ? 'submenu-open' : 'submenu-closed'}`}>
                {item.submenu.map((subItem, subIndex) => (
                  <Link to={subItem.route} key={subIndex} className="submenu-item">
                    <SidebarItem
                      title={subItem.display_name}
                      icon={subItem.icon}
                      active={location.pathname === subItem.route}
                    />
                  </Link>
                ))}
              </div>
            </>
          ) : (
            <Link to={item.route}>
              <SidebarItem title={item.display_name} icon={item.icon} active={index === activeItem} />
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
